<template>
  <svg
    width="34"
    height="34"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="34"
      height="34"
      rx="6"
      fill="#FFD9C3"
    />
    <path
      d="M23 10.3333L21.6667 11.6667M21.6667 11.6667L23.6667 13.6667L21.3333 16L19.3333 14M21.6667 11.6667L19.3333 14M16.5933 16.74C16.9376 17.0796 17.2112 17.484 17.3985 17.9299C17.5858 18.3757 17.6831 18.8542 17.6847 19.3378C17.6863 19.8213 17.5923 20.3005 17.4079 20.7475C17.2236 21.1946 16.9527 21.6008 16.6108 21.9428C16.2688 22.2847 15.8626 22.5556 15.4155 22.7399C14.9685 22.9243 14.4893 23.0183 14.0058 23.0167C13.5222 23.0151 13.0437 22.9178 12.5979 22.7305C12.152 22.5432 11.7476 22.2696 11.408 21.9253C10.7401 21.2338 10.3705 20.3076 10.3789 19.3462C10.3872 18.3848 10.7728 17.4652 11.4527 16.7853C12.1325 16.1055 13.0521 15.7199 14.0135 15.7115C14.9749 15.7032 15.9011 16.0728 16.5927 16.7407L16.5933 16.74ZM16.5933 16.74L19.3333 14"
      stroke="#FF8A71"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
